// extracted by mini-css-extract-plugin
export default {"container":"NotesPopup_container__eDpan","content":"NotesPopup_content__dFKoB","notes":"NotesPopup_notes__XKMnx","button":"NotesPopup_button__MteQP"};